import React from 'react';
import ReactDOM from 'react-dom';
import SignUpApp from "./app/app";

ReactDOM.render(
    <React.StrictMode>
        <SignUpApp config={window.config} />
    </React.StrictMode>,
    document.getElementById('app_root')
);